import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetMedcGendDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_MEDC_GEND_DETAILS, token);
  return res;
};

export const AddMedcGend = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_MEDC_GEND, payload, token);
  return res;
};

export const UpdateMedcGend = async (payload, id) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_MEDC_GEND + id, payload, token);
  return res;
};

export const DeleteMedcGend = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_MEDC_GEND + id, id, token);
  return res;
};
